if (!customElements.get('animated-details')) {
  customElements.define('animated-details', class animatedDetails extends HTMLElement {
    constructor() {
      super();
      this.elementToggle = this.querySelector('[data-animated-details-toggle]');
      this.elementTarget = this.querySelector('[data-animated-details-target]');
      this.elementParent = this.closest('[data-animated-details-parent]');

      this.addEventListener('mouseover', () => {
        this.open();
      });
      this.addEventListener('mouseleave', () => {
        this.close();
      })
      // this.elementToggle.addEventListener('click', () => {
      //   if (this.classList.contains('is-open')) {
      //     this.close();
      //   } else {
      //     this.open();
      //   }
      // });

      this.elementToggle.addEventListener(
        'keyup',
        (event) => event.code.toUpperCase() === 'ESCAPE' && this.close()
      );
    }

    open() {
      // this.elementParent.querySelectorAll('animated-details').forEach((element) => {
      //   element.close();
      // });
      
      // this.onBodyClickEvent =
      // this.onBodyClickEvent || this.onBodyClick.bind(this);
      
      // document.body.addEventListener('click', this.onBodyClickEvent);
      
      // this.classList.add('is-open');
      this.classList.add("is-open")
      this.elementTarget.setAttribute('aria-hidden', false);
      // this.elementToggle.setAttribute('aria-expanded', true);
    }

    close() {
      // this.classList.remove('is-open');
      this.classList.remove("is-open")
      this.elementTarget.setAttribute('aria-hidden', true);
      // this.elementToggle.setAttribute('aria-expanded', false);
      document.body.removeEventListener('click', this.onBodyClickEvent);
    }

    onBodyClick(event) {
      if (!this.contains(event.target)) this.close();
    }
  });
}